import { useCallback, useRef } from 'react';
import { useAudioDevice } from 'providers/AudioDeviceProvider';

/** Only the caller that raised the flag may lower it again. */
export function useRecordingFlag() {
  const { setRecordingActive } = useAudioDevice();
  const ownsFlagRef = useRef(false);
  return useCallback(
    (active: boolean) => {
      if (active) {
        ownsFlagRef.current = true;
        setRecordingActive(true);
      } else if (ownsFlagRef.current) {
        ownsFlagRef.current = false;
        setRecordingActive(false);
      }
    },
    [setRecordingActive]
  );
}
